import "twin.macro";

import { useState } from "react";
import { Link } from "react-router";

import { Button, Chip } from "@mui/material";

import { isBefore } from "date-fns";
import _ from "lodash";

import BlockCard, {
  BlockCardActions,
  BlockCardNoContent,
} from "@features/ui/BlockCard";

import { OrderWindow, Program } from "../../../models";
import { formatUtcDate, utcDate } from "../../../utility/utilityFunctions";
import {
  ProgramOrderWindowAssignmentModal,
  isOrderWindowActive,
} from "../../orderWindows";

const OrderWindowCard = ({
  orderWindow,
  active,
}: {
  orderWindow: OrderWindow;
  active: boolean;
}) => {
  const chipLabel = active
    ? "Active"
    : isBefore(utcDate(orderWindow.closeDate), new Date())
      ? "Closed"
      : "Upcoming";
  return (
    <div>
      <Chip
        label={chipLabel}
        color={chipLabel === "Active" ? "info" : "default"}
        size="small"
      />
      <h4 tw="hover:underline text-neutral-800 mt-1">
        <Link to={`/admin/order-windows/${orderWindow.id}`} target="_blank">
          {orderWindow.name}
        </Link>
      </h4>
      <div tw="text-sm text-neutral-500 mt-0.5">
        <p>
          {formatUtcDate(orderWindow.openDate, "MMM d")} -{" "}
          {formatUtcDate(orderWindow.closeDate, "PP")}
        </p>
        <p>In Market {formatUtcDate(orderWindow.inMarketDate, "PP")}</p>
      </div>
    </div>
  );
};

const OrderWindows = ({
  program,
  handleSaveOrderWindows,
}: {
  program: Program;
  handleSaveOrderWindows: (orderWindowIds: string[]) => Promise<any>;
}) => {
  const [assignmentModalOpen, setAssignmentModalOpen] = useState(false);
  const sortedOrderWindows = _.orderBy(
    program.orderWindows,
    ["openDate"],
    ["desc"]
  );

  // Split order windows into active and inactive
  const [activeOws, inactiveOws] = _.partition(
    sortedOrderWindows,
    isOrderWindowActive
  );

  return (
    <BlockCard title="Order Windows">
      {program.orderWindows.length === 0 && (
        <BlockCardNoContent>
          Assign Order Windows to let users place orders
        </BlockCardNoContent>
      )}
      <div tw="max-h-72 -mx-6 px-6 overflow-y-auto space-y-4">
        {activeOws.map((orderWindow) => (
          <OrderWindowCard
            key={orderWindow.id}
            orderWindow={orderWindow}
            active={true}
          />
        ))}
        {inactiveOws.map((orderWindow) => (
          <OrderWindowCard
            key={orderWindow.id}
            orderWindow={orderWindow}
            active={false}
          />
        ))}
      </div>
      <BlockCardActions>
        <Button variant="outlined" onClick={() => setAssignmentModalOpen(true)}>
          Assign
        </Button>
        {assignmentModalOpen && (
          <ProgramOrderWindowAssignmentModal
            onClose={() => setAssignmentModalOpen(false)}
            program={program}
            handleSave={handleSaveOrderWindows}
          />
        )}
      </BlockCardActions>
    </BlockCard>
  );
};

export default OrderWindows;
